export enum PushNotificationStatus {
    DRAFT = 'draft',
    READY_FOR_SEND = 'ready',
    SENT = 'sent',
}